import React, { useMemo, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import {
  openNativeShare,
  openSmsComposer,
  openWhatsAppShare,
} from '../utils/deviceActions';
import ModalShell from './ModalShell';

export default function BookingLinkShareModal({ bookingUrl, professionalName, onClose, onToast }) {
  const [message, setMessage] = useState(
    `Cześć! Tutaj masz mój link do rezerwacji:\n${bookingUrl}\nMożesz wybrać usługę i wysłać prośbę o termin.`
  );

  const sharePayload = useMemo(() => ({
    title: `Rezerwacje ${professionalName || 'ClientWay'}`,
    text: message,
  }), [message, professionalName]);

  async function handleNativeShare(appName) {
    try {
      try {
        await navigator.clipboard.writeText(message);
      } catch {
        // Best-effort copy for apps that drop shared text.
      }

      const shared = await openNativeShare(sharePayload);
      if (!shared) {
        onToast?.({ type: 'info', message: `Skopiowalam wiadomosc. Otworz ${appName || 'wybrana aplikacje'} i wklej tresc.` });
      } else {
        onToast?.({ type: 'info', message: `Wybierz ${appName || 'aplikacje'} z listy udostepniania. Wiadomosc zostala tez skopiowana awaryjnie.` });
      }
    } catch (error) {
      if (error?.name !== 'AbortError') {
        onToast?.({ type: 'error', message: 'Nie udalo sie otworzyc systemowego udostepniania.' });
      }
    }
  }

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(message);
      onToast?.({ type: 'success', message: 'Wiadomosc zostala skopiowana.' });
    } catch {
      onToast?.({ type: 'error', message: 'Nie udalo sie skopiowac wiadomosci.' });
    }
  }

  async function handleMessengerShare() {
    await handleNativeShare('Messenger');
  }

  async function handleInstagramShare() {
    await handleNativeShare('Instagram');
  }

  return (
    <ModalShell title="Udostępnij link" onClose={onClose} className="share-modal">

        <div className="modal-form">
          <div className="form-group">
            <label>Link do rezerwacji</label>
            <input type="text" readOnly value={bookingUrl} />
          </div>

          <div className="form-group">
            <label>Wiadomosc</label>
            <textarea
              rows={5}
              value={message}
              onChange={(event) => setMessage(event.target.value)}
            />
          </div>

          <div className="share-qr-box">
            <div>
              <div className="share-qr-title">Kod QR do rezerwacji</div>
              <div className="share-qr-subtitle">Klientka moze zeskanowac kod i od razu wejsc do rezerwacji.</div>
            </div>
            <div className="share-qr-code">
              <QRCodeSVG value={bookingUrl} size={132} bgColor="transparent" fgColor="#8f5568" includeMargin />
            </div>
          </div>

          <div className="share-actions-grid">
            <button type="button" className="btn-secondary" onClick={() => handleNativeShare('udostepnianie systemowe')}>
              Udostepnij...
            </button>
            <button type="button" className="btn-secondary" onClick={() => openSmsComposer('', message)}>
              SMS
            </button>
            <button type="button" className="btn-secondary" onClick={() => openWhatsAppShare(message)}>
              WhatsApp
            </button>
            <button type="button" className="btn-secondary" onClick={handleMessengerShare}>
              Messenger
            </button>
            <button type="button" className="btn-secondary" onClick={handleInstagramShare}>
              Instagram
            </button>
          </div>

          <p className="privacy-note">
            Messenger i Instagram korzystaja tu z systemowego udostepniania. Po kliknieciu wybierz aplikacje z listy, a jesli pokaze sie sam link, tresc masz juz skopiowana do schowka.
          </p>

          <div className="modal-footer">
            <button type="button" className="btn-ghost" onClick={onClose}>Zamknij</button>
            <button type="button" className="btn-primary" onClick={handleCopy}>Kopiuj wiadomosc</button>
          </div>
        </div>
    </ModalShell>
  );
}